import { defineMessages } from 'react-intl'

export default defineMessages({
  get_report: {
    id: 'containers.ReportPage.get_report',
    defaultMessage: 'Get report',
  },
  download_csv: {
    id: 'containers.ReportPage.download_csv',
    defaultMessage: 'Get CSV',
  },
})
